import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operational',
})
export class OperationalPipe implements PipeTransform {
  public transform(value: string): string {
    return value === 'operational' ? 'Operational' : 'Not Operational';
  }
}
